module.exports = __webpack_public_path__ + "media/images/icon/navigation/portfolio-3a39163c32fb243c73dc3b3fb5f4dbe8.svg";